import { IconSize } from 'assets/icons/icon-sizes';
import ExternalLinkIcon from 'assets/icons/navigation/ExternalLinkIcon';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { sizes, theme } from 'theme';
import { BodyRegular } from './Elements';
import strings from '../strings/strings.json';

type StandardLinkProps = {
    linkUrl: string;
    linkText: string;
};

export function StandardLink({ linkUrl, linkText }: StandardLinkProps) {
    // Include linkText in aria-label for screen reader distinction
    const ariaLabel = `${linkText} ${strings.general.openInNewTab}`;
    return (
        <StandardLinkStyle to={linkUrl} target="_blank" aria-label={ariaLabel}>
            <BodyRegular>{linkText}</BodyRegular>
            <LinkIconContainer>
                <ExternalLinkIcon colour={theme.linkColour} size={IconSize.SMALL} />
            </LinkIconContainer>
        </StandardLinkStyle>
    );
}

const LinkIconContainer = styled.div`
    min-width: ${IconSize.SMALL}px;
    min-height: ${IconSize.SMALL}px;
`;

const StandardLinkStyle = styled(Link)`
    display: flex;
    gap: ${sizes.spacingXs};
    color: ${theme.linkColour};
    text-decoration: underline;
    &:focus {
        background-color: ${theme.linkFocusBackgroundColour};
        border: 1px solid ${theme.linkFocusBorderColour};
        outline: ${theme.linkFocusBorderColour};
        border-radius: 4px;
    }
    &:hover {
        background-color: ${theme.linkHoverBackgroundColour};
        border-radius: 4px;
    }
`;
